import { api } from '../api';
// Keep an uncertain mutation's key across retries, even when a component reloads
// its data. A changed body is a new intent; a successful receipt retires its key.
const pending = new Map<string, string>();
export const alphaApi: typeof api = async <T>(path: string, options?: RequestInit): Promise<T> => {
  if (options?.method !== 'POST' || typeof options.body !== 'string') return api<T>(path, options);
  const body = JSON.parse(options.body);
  if (!body.idempotencyKey) return api<T>(path, options);
  const { idempotencyKey, ...intent } = body,
    signature = JSON.stringify([path, intent]);
  const key = pending.get(signature) ?? idempotencyKey;
  pending.set(signature, key);
  const result = await api<T>(path, {
    ...options,
    body: JSON.stringify({ ...intent, idempotencyKey: key }),
  });
  pending.delete(signature);
  return result;
};
